<script>
import { mapGetters } from 'vuex';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'OrganizationalUnitBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    organizationalUnit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'organizationalUnit',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
};
</script>

<template>
  <div class="organizationalUnit-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md8 xs12>
        <h4 class="organizationalUnit-detail-tab-title">Stammdaten</h4>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('organizationalUnit.name')" md4 py-0>
            <v-text-field
              v-model="organizationalUnit.name"
              label="Firma"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md8 py-0/>

          <v-flex v-if="isFieldVisible('organizationalUnit.isDelete')" md4 py-0>
            <v-switch
              v-model="organizationalUnit.isDelete"
              label="Gelöscht"
              height="0"
              :readonly="!auth.hasDeleteRights"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
